import React, { useMemo } from 'react';
import { useQuery } from 'hooks/apollo';
import { gql } from '@apollo/client';
import { Select, Space } from 'antd';
import Flag from 'components/Flag';

const GET_COUNTRIES = gql`
  query CountrySelect {
    countries {
      id
      name
    }
  }
`;

const CountrySelect = ({ countryCodes = [], excludedCountryCodes = [], ...props }) => {
  const { data: { countries = [] } = {} } = useQuery(GET_COUNTRIES, {
    fetchPolicy: 'cache-first',
  });

  const options = useMemo(() => countries.filter(c => {
    if (countryCodes.length && !countryCodes.includes(c.id)) return false;
    if (excludedCountryCodes.length && excludedCountryCodes.includes(c.id)) return false;
    return true;
  }).map(c => ({
    value: c.id,
    name: c.name,
    label: (
      <Space>
        <Flag countryCode={c.id} />
        {c.name}
      </Space>
    ),
  })), [countries, countryCodes, excludedCountryCodes]);

  return (
    <Select
      filterOption={(input, option) => option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
      showSearch
      options={options}
      {...props}
    />
  );
};

export default CountrySelect;
